<template>
  <div class="dynamic-attr-text"  :class="(attrObj.isCheckError?'is-check-error':'')">
    <div
      :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
      :style="{fontSize:$pScreen.titleS}"
    >
      <span>{{ showNum(attrObj, currentPage) }} {{attrObj.title}}</span>
      <span style="color:#C3C3C3;display:block" :style="{'font-size': showFontSize(attrObj)?'14px':'12px'}">多选题</span>
    </div>
    <div class="check-content">
      <div
        v-for="(item,index) in attrObj.optionList"
        :key="index"
        class="radio-options"
        :style="{fontSize:$pScreen.textS, 'font-size': showFontSize(attrObj)?'14px':'12px'}"
      >
        <div v-if="attrObj.disabled" class="disabledCheckbox"></div>
        <div class="radio-options-content" @click="selectAttr(index)">
          <div class="radio-options-value">
            <Icon
              type="text"
              notTimeout
              style="font-size: 16px;vertical-align:middle;"
              :icon="item._isSelect?'check-square':'square'"
              :class="item._isSelect?'selected':''"
              :disabled="attrObj.disabled"
            ></Icon>
          </div>
          <div class="radio-options-label">
            <span>{{item.optionContent}}</span>
          </div>
          
        </div>
      </div>
      <div v-if="attrObj.isCheckError" class="errorTip">请选择选项</div>
    </div>
  </div>
</template>


<script>
import { FormType } from '../../../../commons/commonVariables.js';
export default {
  props: {
    attrObj: Object,
    currentPage: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {};
  },
  created() {
    let self = this;
    this.attrObj.optionList.filter(function(item){
      if(!item._isSelect){
        self.$set(item, "_isSelect", false)
      }
    });
  },
  //初始化后调用
  mounted: function() {},
  methods: {
    selectAttr(index) {
      const item = this.attrObj.optionList[index];
      item._isSelect = !item._isSelect;
    },
    // 只有趣味表单才展示题号
    showNum(item, current){
      if(item.formType !== FormType.interestForm){
        return ''
      } else {
        return `${current + 1}.`
      } 
    },
    // 趣味表单备注项和选项字体14，普通表单默认12
    showFontSize(item){
      return item.formType === FormType.interestForm;
    }
  }
};
</script>
<style>
  .radio-options{
    position: relative;
    margin-top: 10px;
  }
  .disabledCheckbox{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 666;
  }
  .radio-options-content {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .radio-options-label {
    margin-left: 5px;
  }
  .errorTip {
    width: 100%;
  }
  .check-content {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/checkbox.vue